import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/Test%20Die%20Grotesk/test-die-grotesk-vf-roman.woff2%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/Test%20Die%20Grotesk/test-die-grotesk-vf-italic.woff2%22,%22style%22:%22italic%22}],%22weight%22:%22100%20900%22,%22variable%22:%22--font-app%22,%22display%22:%22swap%22}],%22variableName%22:%22testDieGrotesk%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'testDieGrotesk', 'testDieGrotesk Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
